// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Topbar from "./components/Topbar";
import ProbiomaNavbar from "./components/ProbiomaNavbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import AboutUs from "./pages/AboutUs";
import Wholesale from "./pages/Wholesale";
import Cart from "./components/cart";   // ✅ import your new Cart page
import { CartProvider } from "./context/CartContext"; // ✅ import provider
import Checkout from "./pages/Checkout";

function App() {
  return (
    <CartProvider>
      <Router>
        <Topbar />
        <ProbiomaNavbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/wholesale" element={<Wholesale />} />
            <Route path="/cart" element={<Cart />} /> {/* ✅ add cart route */}
            <Route path="/checkout" element={<Checkout />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
